import rootSaga from '../Sagas/'
import { combineReducers } from 'redux'
import configureStore from './CreateStore'

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  auth: require('./AuthRedux').reducer,
  settings: require('./SettingsRedux').reducer,
  contactButton: require('./ContactButtonRedux').reducer,
  selection: require('./SelectionRedux').reducer,
  calendlyEvent: require('./CalendlyEventRedux').reducer,
  shopifyProduct: require('./ShopifyProductRedux').reducer,
  appointment: require('./AppointmentRedux').reducer,
  banner: require('./BannerRedux').reducer,
  booking: require('./BookingRedux').reducer,
  emailSettings: require('./EmailSettingsRedux').reducer,
  customer: require('./CustomerRedux').reducer,
  team: require('./TeamRedux').reducer,
  workflow: require('./WorkflowRedux').reducer,
  widget: require('./WidgetRedux').reducer,
  tag: require('./TagRedux').reducer,
  waitlist: require('./WaitlistRedux').reducer,
})

export const { store } = configureStore(reducers, rootSaga)

export default () => {
  let finalReducers = reducers
  // If rehydration is on use persistReducer otherwise default combineReducers

  let { store, sagasManager, sagaMiddleware } = configureStore(
    finalReducers,
    rootSaga
  )

  if (module.hot) {
    module.hot.accept(() => {
      let nextRootReducer = require('./').rootReducer
      store.replaceReducer(nextRootReducer)

      const newYieldedSagas = require('../Sagas').default
      sagasManager.done.then(() => {
        sagasManager.cancel()
        sagasManager = sagaMiddleware.run(newYieldedSagas)
      })
    })
  }
  return { store }
}
